import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Persistence + retention strip for guest surfaces (anonymous access v1 §8).
 *
 * Carries the spec's two messages in one slim line: your trip is safe on this
 * device (persistence parity — the relief moment), and it lives 30 days past
 * your last visit unless you create an account (the retention nudge). The
 * signup link carries ?next= so the claimed trip greets the user right after.
 * Render only for guests; parents own the isGuest check.
 */
const GuestStatusStrip: React.FC = () => {
  const location = useLocation();
  const next = encodeURIComponent(location.pathname + location.search);

  return (
    <div
      style={{
        background: '#e8f2ec',
        border: '1px solid #cfe3d8',
        borderRadius: 12,
        padding: '10px 14px',
        fontSize: 13,
        lineHeight: 1.5,
        color: '#3f4f47',
        marginBottom: 14,
      }}
    >
      Saved on this device for 30 days after your last visit.{' '}
      <Link
        to={`/signup?next=${next}`}
        style={{ color: '#157a55', fontWeight: 600, textDecoration: 'underline' }}
      >
        Create a free account
      </Link>{' '}
      to keep it forever.
    </div>
  );
};

export default GuestStatusStrip;
